import Vue from "vue";

export default {
    getPuestos(parametros) {
        return Vue.axios
            .get("catalogo/puestos/find", { params: parametros })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    },
    getPuesto(id) {
        return Vue.axios
            .get("catalogo/puestos/" + id)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    },
    updatePuesto(parametros) {
        return Vue.axios
            .put("catalogo/puestos", parametros)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    },
    deletePuesto(id) {
        return Vue.axios
            .delete("catalogo/puestos/" + id)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    },
    addPuesto(parametros) {
        return Vue.axios
            .post("catalogo/puestos", parametros)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    },
    duplicar(parametros) {
        return Vue.axios
            .post("catalogo/puestos/duplicar", parametros)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    },
    updateMasivo(parametros) {
        return Vue.axios
            .post("catalogo/puestos/update-masivo", parametros)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    },
};
